import { ReactNode } from 'react';

type TopSectionProps = {
    title: string;
    description: string | ReactNode;
};

function TopSection({ title, description }: TopSectionProps): JSX.Element {
    return (
        <section className="grid gap-y-4">
            <label className="text-sm font-medium text-gray-800 dark:text-gray-200">{title}</label>
            <p className="text-xs font-normal text-gray-600 dark:text-gray-400">{description}</p>
        </section>
    );
}

export default TopSection;
